import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { loadCarrierByIdFailed, loadCarrierByIdSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* loadCarrierById(action) {
  try {
    const url = `${BACKEND_URL}/registries/carriers/${action.payload}`;
    const dataResponse = yield makeRequest(url, {
      with_trashed: 1,
    }, action, 'GET', true);
    if (dataResponse.status === OK) {
      const data = yield dataResponse.json();
      yield put(loadCarrierByIdSuccessful(data.data));
      yield call(resolveActionPromise(action, data.data));
    } else {
      yield put(loadCarrierByIdFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(loadCarrierByIdFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
